
import { Controller } from "stimulus"
import i18next from "i18next"
export default class extends Controller {
  static targets = ["dateInputs", "showDatesOption", "hideDatesOption", "typeSelector", "textPreview", "imagePreview", "inputForLiveText", "liveText", "bannerImageError"]

  connect() {
    this.loadDateInputs()
    this.manageTypeDisplay(this.typeSelectorTarget.value)
    main.loadWebsiteWideElements()

    if (this.inputForLiveTextTarget.value.length == 0) {
      this.displayTextEditHint()
    }
  }

  checkBannerImage(event) {
    const fileInput = event.target
    console.log(fileInput)
    var selectedFile = fileInput.files[0]
    var fileSize = selectedFile.size / 1024 / 1024 // size in Mb
    if (fileSize > 10) {
      console.log("TOO HEAVY", fileSize)
      fileInput.classList.add("is-invalid")
      this.bannerImageErrorTarget.classList.remove("d-none")
    } else {
      fileInput.classList.remove("is-invalid")
      this.bannerImageErrorTarget.classList.add("d-none")
    }

  }

  loadDateInputs() {
    var showDates = false

    for (var i = 0; i < this.dateInputs.length; i++) {
      if (this.dateInputs[i].value) {
        showDates = true
      }
    }

    if (showDates) {
      this.showDatesOptionTarget.checked = true
      this.showDateInputs()
    } else {
      this.hideDatesOptionTarget.checked = true
      this.hideDateInputs()
    }
  }

  hideDateInputs() {
    var dateInputs = this.dateInputs
    for (var i = 0; i < dateInputs.length; i++) {
      dateInputs[i].value = ""
    }

    this.dateInputsTarget.hidden = true
  }

  showDateInputs() {
    this.dateInputsTarget.hidden = false
  }

  showSelectedType(event) {
    this.manageTypeDisplay(event.target.value)
  }

  manageTypeDisplay(value) {
    if (value == "text") {
      this.textPreviewTarget.hidden = false
      this.imagePreviewTarget.hidden = true
    } else {
      this.textPreviewTarget.hidden = true
      this.imagePreviewTarget.hidden = false
    }
  }

  updateLiveText(event) {
    console.log("updatelive text")
    if (event.target.value == 0) {
      this.displayTextEditHint()
    } else {
      this.liveTextTarget.innerHTML = event.target.value
    }
  }

  displayTextEditHint() {
    this.liveTextTarget.innerHTML = i18next.t("announcementEditNameHint")
  }

  get dateInputs() {
    return this.dateInputsTarget.querySelectorAll("input[type='date']")
  }
}
